import {getRandomColor} from "../../../utils/GetRandomColor";
import {Player} from "@lottiefiles/react-lottie-player";
import reId from "../../../assets/json/1-re-id.json";
import IconText from "../../IconText";
import {faIdCard} from "@fortawesome/free-solid-svg-icons";

export default function ReId() {

    const lottieStyle = {
        border: `5px solid ${getRandomColor()}`,
    };
    
    return (
        <div className={"blog-body"}>
            <h1><IconText text={"1. Re-ID"} icon={faIdCard}/></h1>

            <h2>Question</h2>
            <div className={"blog-quote"}>
                <p>
                    There's some unrest in the minion ranks: minions with ID numbers like "1", "42", and other
                    "good"
                    numbers
                    have been lording it over the poor minions who are stuck with more boring IDs. To quell the
                    unrest,
                    Commander Lambda has tasked you with reassigning everyone new random IDs based on a Completely
                    Foolproof
                    Scheme.
                </p>
                <p>
                    Commander Lambda has concatenated the prime numbers in a single long string:
                    "2357111317192329...". Now
                    every minion must draw a number from a hat. That number is the starting index in that string of
                    primes,
                    and
                    the minion's new ID number will be the next five digits in the string. So if a minion draws "3",
                    their
                    ID
                    number will be "71113".
                </p>
                <p>
                    Help the Commander assign these IDs by writing a function solution(n) which takes in the
                    starting index
                    n of
                    Lambda's string of all primes, and returns the next five digits in the string. Commander Lambda
                    has a
                    lot of
                    minions, so the value of n will always be between 0 and 10000.
                </p>
                <p>
                    <b>Test cases</b>
                </p>
                <p>
                    Input: <br/>
                    solution.solution(0) <br/>
                    Output: <br/>
                    23571 <br/><br/>

                    Input: <br/>
                    solution.solution(3) <br/>
                    Output: <br/>
                    71113 <br/>
                </p>
            </div>

            <h2>Solution</h2>

            <p>
                This one is pretty straight-forward. Since the question states that the value of n will always be
                between 0
                and 10000, we can simply create a string to store the prime numbers until the length of the string
                is 10005.
                Then we can ask for the n value and return the next 5 digits from the string.
            </p>
            <p>
                To find the prime numbers, we can use a for loop. Starting from 2, we can check if the number is
                divisible
                by
                any other number. If it is not divisible by any number, then it is a prime number. We can add this
                number to
                our string.
            </p>

            <div className="blog-lottie-wrapper">
                <Player
                    style={lottieStyle}
                    src={reId} className={"blog-lottie"}
                    autoplay
                    loop
                    background={"#e9e8e6"}>
                </Player>
            </div>

            <p>
                It is not possible to calculate prime numbers without brute forcing (for now, 2024), so if you come
                up with
                a formula to find the prime numbers, congratulations on your Nobel Prize.
            </p>
            <p>
                It is also possible to use <code>i/2</code> as the upper limit of the range in the for loop for
                better
                optimization, since a number is not divisible by any number greater than half of itself.
            </p>

            <h2>Code</h2>

            <pre><code className="language-python">{`# Creating a string of prime numbers
prime_string = ""

# Finding the primes until the length of the string is 10005
i = 2
while len(prime_string) < 10005:
    for j in range(2, i):
        if i % j == 0:
            break
    else:
        prime_string += str(i)
    i += 1

def solution(n):
    # Returning the next five digits in the string
    return prime_string[n:n+5]`}</code></pre>
        </div>
    )
}